export enum AppointmentPlusDateFormats {
  API = 'yyyyMMdd'
}

export enum DockTypes {
  SAPTS = 'sapts',
  MAPTS = 'mapts'
}
